import type { DuctedPanelSelection } from 'components/equipment-page/ducted-system-detail-panel';
import type { DuctedPairPick } from 'features/ui/ducted-pair-pick-types';

function accessoryOptionsOf(selection: DuctedPanelSelection): string | null {
  return (
    (selection.combination.Accessories as string | null | undefined) ?? null
  );
}

export function syncDuctedPairPick(
  pick: DuctedPairPick,
  live: DuctedPanelSelection | null
): DuctedPairPick | null {
  if (live === null || live.combination.ID === pick.selection.combination.ID) {
    return null;
  }
  const keepsAccessoryPicks =
    pick.accessoryPicks !== undefined &&
    accessoryOptionsOf(live) === accessoryOptionsOf(pick.selection);
  return {
    selection: live,
    ...(keepsAccessoryPicks ? { accessoryPicks: pick.accessoryPicks } : {})
  };
}
